import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a5f1507"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "nav-header-box" }
const _hoisted_3 = { class: "page-inner-container" }
const _hoisted_4 = { class: "faq-list-box" }
const _hoisted_5 = { class: "page-inner-container" }
const _hoisted_6 = { key: "noc" }
const _hoisted_7 = { key: "qecit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Banner = _resolveComponent("Banner")!
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_FaqNOC = _resolveComponent("FaqNOC")!
  const _component_FaqQECIT = _resolveComponent("FaqQECIT")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Banner, { image: _ctx.BannerImage }, null, 8, ["image"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_NavHeader, {
          list: _ctx.activityTypeList,
          onChange: _ctx.onActivityTypeChange
        }, null, 8, ["list", "onChange"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _createVNode(_component_FaqNOC)
        ], 512), [
          [_vShow, _ctx.current === 1]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createVNode(_component_FaqQECIT)
        ], 512), [
          [_vShow, _ctx.current === 2]
        ])
      ])
    ])
  ]))
}